import React from 'react';
import Spinner from "react-bootstrap/Spinner";
import Header from './Header';
import Footer from './Footer';

import CardPublications from '../cards/CardPublications';

export default class Publications extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			publicaciones: [],
			loading: true			
		};
		
	}
	render() {
		return (
			<div className="about-page">
				<Header />
				<h1>Publications</h1>
				<hr/>
				<div className="content-about">
					{this.state.loading ? <Spinner /> :<CardPublications pub={this.state.publicaciones} id="publications" item='10' />}
				</div>
				<Footer />
			</div>
		)
	}
	componentDidMount(){
		window.scrollTo(0,0);
		fetch(process.env.PUBLIC_URL+"/assets/json/publications-v2.json").then(res=>res.json()).then(publicaciones=>this.setState({publicaciones, loading: false}));
	}

}